module.exports = __webpack_public_path__ + "static/media/folder3.5c7457c0.png";